/* Product showcase javascript - start */
var product_showcase_wrapper = document.querySelectorAll('.product-showcase-wrapper');

if(product_showcase_wrapper.length > 0){
    var thumbs = document.querySelectorAll('.product-thumbnails-image img');
    //console.log('product_showcase_wrapper found: ' + product_showcase_wrapper.length);
    [].forEach.call(thumbs, function(div) {
      div.addEventListener("mouseenter", function( event ) {
        var get_image_src = this.getAttribute('large-img');
        var variant_url = this.getAttribute('data-variant-id');
        var get_current_image_src = this.closest(".product-showcase-information").querySelector('.product-main-image .product-main-imagetag').style.backgroundImage.slice(4, -1).replace(/"/g, "");
        var targetmainimage = this.closest(".product-showcase-information").querySelector('.product-main-image .product-main-imagetag');
            
        if(get_image_src !== get_current_image_src){
            this.closest(".product-showcase-information").querySelector('.button-primary').setAttribute('href', variant_url);
            this.closest(".product-showcase-information").querySelector('.main-image-anchor').setAttribute('href', variant_url);
            targetmainimage.classList.add("img-hidden");
            setTimeout(function(){ targetmainimage.style.backgroundImage = "url(" + get_image_src + ")"; }, 150);
            setTimeout(function(){ targetmainimage.classList.remove("img-hidden"); }, 150);
        }
      });
    });
}

/* Product showcase javascript - end */